import { ListSystemsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { SystemLiteModel } from '~/shared/models/system/SystemLiteModel';

export class ListSystemsModel {
  readonly systems: SystemLiteModel[];

  private systemByIdMap = new Map<string, SystemLiteModel>();

  constructor(listSystemsResponse: ListSystemsResponse) {
    this.systems = listSystemsResponse.systems
      .map((system) => new SystemLiteModel(system))
      .sort((a, b) => a.title.localeCompare(b.title));

    this.systems.forEach((system) => {
      this.systemByIdMap.set(system.id, system);
    });
  }

  systemById(systemId: string) {
    return this.systemByIdMap.get(systemId);
  }
}
